// extracted by mini-css-extract-plugin
export default {"background":"WMw2AnOSmCJk2myUuntt"};